<script lang="ts" setup>
import { useCloudStore } from '~/stores/cloud'

const cloud = useCloudStore()
const { t } = useI18n()

const label = computed(() => cloud.session?.user.name || cloud.session?.user.handle || t('cloud.account'))
const safeAvatarUrl = computed(() => {
  const value = cloud.session?.user.avatarUrl
  if (!value)
    return undefined
  try {
    const url = new URL(value)
    return url.protocol === 'https:' ? url.href : undefined
  }
  catch {
    return undefined
  }
})
</script>

<template>
  <div v-if="cloud.config.loginEnabled" class="cloud-account">
    <RouterLink
      v-if="cloud.isAuthenticated"
      to="/user"
      class="command-button command-button--quiet cloud-account__button"
      :aria-label="t('cloud.manage_account')"
    >
      <img v-if="safeAvatarUrl" class="cloud-account__avatar" :src="safeAvatarUrl" alt="" referrerpolicy="no-referrer">
      <span v-else class="cloud-account__icon" i-ri-user-3-line aria-hidden="true" />
      <span class="cloud-account__label">{{ label }}</span>
      <span class="cloud-account__status" :class="`cloud-account__status--${cloud.status}`" aria-hidden="true" />
    </RouterLink>
    <button
      v-else
      type="button"
      class="command-button command-button--quiet cloud-account__button"
      :disabled="cloud.status === 'loading'"
      :aria-busy="cloud.status === 'loading'"
      @click="cloud.login"
    >
      <span class="cloud-account__icon" :class="cloud.status === 'loading' ? 'i-ri-loader-4-line animate-spin' : 'i-ri-user-3-line'" aria-hidden="true" />
      <span>{{ cloud.status === 'loading' ? t('cloud.connecting') : t('cloud.login') }}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.cloud-account {
  margin-left: auto;
}

.cloud-account__avatar,
.cloud-account__icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.cloud-account__avatar {
  border-radius: 50%;
  object-fit: cover;
  background: rgb(127 127 127 / 10%);
}

.cloud-account__icon {
  color: inherit;
  background-color: currentColor;
}

.cloud-account__label {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cloud-account__status {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;

  &--saving,
  &--loading {
    background: #f59e0b;
  }

  &--error {
    background: #ef4444;
  }
}
</style>
